import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-useractivity",
  templateUrl: "./useractivity.component.html",
  styleUrls: ["./useractivity.component.scss"],
})
export class UseractivityComponent implements OnInit {
  displayedColumns: string[] = ["Sno", "createdOn", "activityDetail"];
  dataSource: any;
  modified_By: any;
  userid: any;
  user: any;
  userList: any[];

  userActivityList: any;
  userActivityId: any;
  paginator: any;

  public shown = {
    grid: true,
    Form: false,
  };

  Useractivity = new FormGroup({
    userActivityId: new FormControl(),
    userId: new FormControl(),
    activityDetail: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
  }

  constructor(
    private daoService: DaoService,
    private token: LstorageService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UseractivityComponent>
  ) {}

  ngOnInit() {
    this.daoService.fuseractivityId.subscribe((data: any) => {
      console.log("edit data");
      console.log(data);
      this.userActivityId = data;
    });
    if (this.userActivityId) {
      this.modified_By = jwtDecode(this.token.getToken());
      console.log("userActivityId");
      console.log(this.userActivityId);
      this.daoService
        .getUseractivityById(this.userActivityId)
        .subscribe((data: any) => {
          console.log("dgdfgdj");
          console.log(data);
          // this.Useractivity = this.fb.group({
          //   userActivityId: [this.userid],
          //       userId: [this.userid],
          //       createdOn: [data.createdOn],
          //       activityDetail: [data.activityDetail],
          // });
          this.userActivityList = data;
          this.dataSource = new MatTableDataSource(this.userActivityList);
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  closeUseractivityForm() {
    this.dialogRef.close();
    this.dataSource.paginator = this.paginator;
  }
}
